import axios from "utils/axios";
import { stringify } from "query-string";

export const getKpiForms = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/kpi/forms/pagination?${query}`);
};

export const getKpiForm = (data) => {
  return axios.get(`/hr/kpi/forms/${data?.id}`);
};

export const addKpiForm = (data) => {
  return axios.post(`/hr/kpi/forms`, data);
};

export const duplicateKpiForm = (data) => {
  return axios.post(`/hr/kpi/forms/${data?.id}/duplicate`, data);
};

export const editKpiForm = (data) => {
  return axios.put(`/hr/kpi/forms/${data?.id}`, data);
};

export const deleteKpiForm = (id) => {
  return axios.delete(`/hr/kpi/forms/${id}`);
};

export const activateKpiForm = (id) => {
  return axios.patch(`/hr/kpi/forms/${id}/activate`);
};

export const deactivateKpiForm = (id) => {
  return axios.patch(`/hr/kpi/forms/${id}/deactivate`);
};
